import { render } from "./WaitPage.vue?vue&type=template&id=3f880bea&scoped=true"
import script from "./WaitPage.vue?vue&type=script&lang=js"
export * from "./WaitPage.vue?vue&type=script&lang=js"

import "./WaitPage.vue?vue&type=style&index=0&id=3f880bea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f880bea"]])

export default __exports__